const page = {
  onestoreSubscribeList: 'onestore-subscribe-list-page',
  onestoreSubscribeDetail: 'onestore-subscribe-detail-page',
  home: 'home-page',
  service: 'service-page',
  accountSetting: 'account-setting-page',
  accountUpgrade: 'account-upgrade-page',
  profile: 'profile-page',
  changePassword: 'change-password-page',
  safeQuession: 'safe-quession-page',
  bindEmail: 'bind-email-page',
  findPwd: 'find-pwd-page',
  installService: 'install-service-page',
  accountFollow: 'account-follow-page',
  loginFollow: 'login-follow-page',
  registProfile: 'regist-profile-page',
  tokenLogin: 'tokenLogin'
};

export default {
  /**
   * event：dom事件绑定
   * key：类名
   * type：触发操作（click、change等）
   * event：触发上报事件名
   * newPage：是否会导致页面跳转，如果true，则页面跳转会上报jump-page，否则上报leave-page
   * pageName: 固定的上报页面，非固定页面或公共页面的不用填，自动使用上一次上报页面
   */
  event: {
    'j-mods-guide-mods': [
      {
        type: 'click',
        event: 'click-mods-guide-mods'
      }
    ],
    'j-mods-guide-service': [
      {
        type: 'click',
        event: 'click-mods-guide-service'
      }
    ],
    'j-subscribe-privacy': [
      {
        type: 'click',
        event: 'click-subscribe-privacy-btn'
      }
    ],
    'j-cancel-subscribe': [
      {
        type: 'click',
        event: 'click-cancel-subscribe-btn',
        pageName: page.onestoreSubscribeDetail
      }
    ],
    'j-cancle-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-cancel-btn'
      }
    ],
    'j-sure-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-sure-btn'
      }
    ],
    'j-close-tip-btn': [
      {
        type: 'click',
        event: 'click-popup-close-btn'
      }
    ],
    'j-account-delete-sure': [
      {
        type: 'click',
        event: 'click-account-delete-sure-btn'
      }
    ],
    'j-account-delete-cancel': [
      {
        type: 'click',
        event: 'click-account-delete-cancel-btn'
      }
    ],
    'j-account-delete-close': [
      {
        type: 'click',
        event: 'click-account-delete-close-btn'
      }
    ],
    'j-account-delete-agreement': [
      {
        type: 'click',
        event: 'click-account-delete-agreement-part'
      }
    ],
    'j-account-delete-btn': [
      {
        type: 'click',
        event: 'click-account-delete-passport-entry'
      }
    ],
    'j-h5-pwa-install-btn': [
      {
        type: 'click',
        event: 'click-add-to-pwa'
      }
    ],
    'j-token-login': [
      {
        type: 'click',
        event: 'click-token-login-entry',
        pageName: page.tokenLogin
      }
    ],
    'j-official-pay': [
      {
        type: 'click',
        newPage: 'true',
        event: 'click-official-pay',
        pageName: page.tokenLogin
      }
    ],
    'j-change-account': [
      {
        type: 'click',
        event: 'click-change-account',
        pageName: page.tokenLogin
      }
    ]
  },
  /**
   * router:路由更新时触发，这个需要在入口手动触发方法
   * key：路由名
   * event：触发上报事件名，统一前缀会加上‘enter-。当event为空时不上报
   */
  router: {
    onestoreSubscribe: { event: page.onestoreSubscribeList },
    onestoreSubscribeDetail: { event: page.onestoreSubscribeDetail },
    home: { event: page.home },
    service: { event: page.service },
    accountSetting: { event: page.accountSetting },
    accountUpgrade: { event: page.accountUpgrade },
    profile: { event: page.profile },
    safeQuession: { event: page.safeQuession },
    bindEmail: { event: page.bindEmail },
    findPwd: { event: page.findPwd },
    installService: { event: page.installService },
    accountFollow: { event: page.accountFollow },
    loginFollow: { event: page.loginFollow },
    registProfile: { event: page.registProfile },
    tokenLogin: { event: page.tokenLogin }
  }
};
